import React from 'react';

function Annotations(props) {
    return (
        <div style={{ backgroundColor: '#cccccc', fontSize: '12px' }}>
            <ul id='FlightListAnnotations'
                className='list-group list-group-horizontal justify-content-end text-dark text-nowrap py-1'>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    <span className='bg-green d-block border border-dark'
                        style={{ width: '10px', height: '10px' }}></span>
                    <span className='ml-1'>F/No - Previous Data</span>
                </li>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    <span className='bg-yellow d-block border border-dark'
                        style={{ width: '10px', height: '10px' }}></span>
                    <span className='ml-1'>From - Tankering Sector</span>
                </li>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    <span className='bg-purple d-block border border-dark'
                        style={{ width: '10px', height: '10px' }}></span>
                    <span className='ml-1'>Tail - MEL/CDL Exists</span>
                </li>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    <span className='text-orange px-1'
                        style={{ backgroundColor: '#213852' }}>A-Z</span>
                    <span className='ml-1'>ETD > STD + 90</span>
                </li>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    {/* <span className='bg-orange d-block border border-dark'
                        style={{ width: '10px', height: '10px' }}></span> */}
                    <span className='text-gold px-1'
                        style={{ backgroundColor: '#213852' }}>A-Z</span>
                    <span className='ml-1'>Pilot - First Flight</span>
                </li>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    <span className='bg-red d-block border border-dark'
                        style={{ width: '10px', height: '10px' }}></span>
                    <span className='ml-1'>EZFW - CFP > 500</span>
                </li>
            </ul>

            <ul id='FlightListStats'
                className='list-group list-group-horizontal justify-content-end text-dark text-nowrap py-1'>
                <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    Total Flights - {props.count}
                </li>
                {/* <li className='list-group-item d-flex align-items-center bg-transparent p-0 px-2'>
                    Last Updated - {props.updated}
                </li> */}
            </ul>
        </div>
    );
}

export default Annotations;